import { takeEvery, call, put } from 'redux-saga/effects';
import {
  sendRequestDeleteInExecutorList,
  sendRequestDeleteInCustomerList,
  requestFinished
} from '../reduce';
import { timeoutCall } from '../../../../../../../utils/sagaHalper';
import UserBlackListService from '../../../../../services/UserBlackListService';

import * as clientNoticesActions from '../../../../../../main/reducers/static/states/clientNotices/reducer';

function* removeUserBlackListFormSaga(reducerName, apiServiceFunc, action) {
  try {
    const result = yield call(
      timeoutCall,
      apiServiceFunc,
      action.payload.blockedUserId
    );
    if (result) {
      if (result.status === 204) {
        yield put(
          clientNoticesActions.addClientNotice({
            type: 'success',
            message: 'Пользователь удален из черного списка'
          })
        );
      }
    }
    yield put(
      requestFinished(reducerName, result.status, result.status === 204)
    );
  } catch (error) {
    console.log(error);
    yield put(requestFinished(reducerName));
  }
}

export default function getSaga(reducerName) {
  return [
    takeEvery(
      sendRequestDeleteInExecutorList(reducerName).type,
      removeUserBlackListFormSaga,
      reducerName,
      UserBlackListService.deleteBlockedUserInExecutorList
    ),
    takeEvery(
      sendRequestDeleteInCustomerList(reducerName).type,
      removeUserBlackListFormSaga,
      reducerName,
      UserBlackListService.deleteBlockedUserInCustomerList
    )
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userBlackList/reducers/static/forms/removeUserBlackListForm/sagas/removeUserBlackListFormSaga.js